import { FC, PropsWithChildren, useRef } from 'react';
import { useBoolean } from 'hooks';
import { Popper, Box } from 'components';
import { PopperPlacementType } from '@abbyy/react-ui';

export const TooltipWrapper: FC<
    PropsWithChildren<{
        text: string;
        show: boolean;
        placement: PopperPlacementType;
        hasArrow?: boolean;
        maxWidth?: string;
    }>
> = ({ children, text, show, placement, hasArrow, maxWidth }) => {
    const formsTitleRef = useRef(null);
    const [isTooltipShown, showTooltip, hideTooltip] = useBoolean();

    return (
        <div
            ref={formsTitleRef}
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}>
            {children}
            <Popper
                isOpen={isTooltipShown && show}
                placement={placement}
                anchorElement={formsTitleRef.current}
                hasArrow={hasArrow}>
                <Box whiteSpace="pre-wrap" maxWidth={maxWidth}>
                    {text}
                </Box>
            </Popper>
        </div>
    );
};
